import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
// import { Modal } from '../Header/AddCampaignModal';
import { IoMdClose } from 'react-icons/io';
import { useState } from 'react';
import OverwriteMain from 'components/newSetup/OVERWRITE_DATA/OverwriteMain';
// import { gridLayout } from './CustomReportTab';
import CustomReportText from './CustomReportText';
import CustomReportFile from './CustomReportFile';
import styled from 'styled-components';
import CustomReportKPI, { KPIvalues } from './CustomReportKPI';
import { Modal } from 'index';
import { GridLayout, UserQuery } from 'API';
import CustomReportQuery from './CustomReportQuery';
import { queryValues } from './CustomReportSection';
import { useCustomReportContext } from 'context/CustomReportContext';
import CustomReportCreative, { CreativeValues } from './CustomReportCreative';

type Props = {
  sectionID: string | null | undefined;
  openedItem: GridLayout;
  layoutState: GridLayout[];
  onFileSaved: (sectionItemID: string, file: File) => void;
  initialFile: File | null;
  fetchFile: (sectionItemID: string) => Promise<File | null>;
  handleModalType: (item: GridLayout | null, type: string | null) => void;
  initialKPI: KPIvalues | null;
  fetchKPI: (sectionItemID: string) => Promise<KPIvalues | null>;
  onKpiSaved: (sectionItemID: string, kpi: KPIvalues) => void;
  initialText: string | null;
  fetchText: (sectionItemID: string) => Promise<string | null>;
  onTextSaved: (sectionItemID: string, text: string) => void;
  initialQuery: queryValues | null;
  fetchQuery: (sectionItemID: string) => Promise<queryValues | null>;
  onQuerySaved: (sectionItemID: string, query: queryValues) => void;
  initialCreative: CreativeValues | null;
  fetchCreative: (sectionItemID: string) => Promise<CreativeValues | null>;
  onCreativeSaved: (sectionItemID: string, creative: CreativeValues) => void;
};

const HeadModulStyled = styled(HeadModul)`
  width: 768px;
  min-height: 60vh;
  max-height: 90vh;
  background-color: white; /* Ensure the modal content is visible */
  border-radius: 8px;
  padding: 20px;
  overflow-y: auto; /* Allow scrolling within the modal content */
  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 50px;
  }

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1vw;
  }

  .tagsContainer {
    display: grid;
    grid-column: span 2;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1vw;
  }
`;

const CustomReportModalAddNew = (props: Props) => {
  const {
    openedItem,
    layoutState,
    handleModalType,
    sectionID,
    initialFile,
    fetchFile,
    onFileSaved,
    initialKPI,
    fetchKPI,
    onKpiSaved,
    initialText,
    fetchText,
    onTextSaved,
    initialQuery,
    fetchQuery,
    onQuerySaved,
    initialCreative,
    fetchCreative,
    onCreativeSaved,
  } = props;
  const capitalizeFirstLetter = (str: string | null) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const { activeCustomReport } = useCustomReportContext();

  const userIsAuthorized = activeCustomReport?.authorized;
  return (
    <Modal>
      <HeadModulStyled
        style={{
          width:
            openedItem.Type === 'chart' || openedItem.Type === 'table' || openedItem.Type === 'kpiQuery'
              ? '90vw'
              : '90vw',
          height: '95vh',
        }}
      >
        <button type="button" className="x" onClick={() => handleModalType(null, null)}>
          {' '}
          <IoMdClose className="closeIcon" />
        </button>
        <ModulContainer>
          {userIsAuthorized && (
            <h1>
              {openedItem.SectionItemID ? 'Edit' : 'Add New'} {capitalizeFirstLetter(openedItem.Type || '')}
            </h1>
          )}
          {openedItem.Type === 'kpi' && (
            <CustomReportKPI
              handleModalType={handleModalType}
              sectionID={sectionID}
              layoutItem={openedItem}
              modal={true}
              kpiValue={initialKPI}
              fetchKPI={fetchKPI}
              onKpiSaved={onKpiSaved}
            ></CustomReportKPI>
          )}
          {(openedItem.Type === 'chart' || openedItem.Type === 'table' || openedItem.Type === 'kpiQuery') && (
            <CustomReportQuery
              isGraph={openedItem.Type === 'chart' || openedItem.Type === 'kpiQuery'}
              sectionID={sectionID}
              handleModalType={handleModalType}
              layoutItem={openedItem}
              modal={true}
              initialQuery={initialQuery}
              fetchQuery={fetchQuery}
              onQuerySaved={onQuerySaved}
              modalType={openedItem.Type} // Pass the type to handle different logic in CustomReportQuery
            ></CustomReportQuery>
          )}
          {openedItem.Type === 'text' && (
            <CustomReportText
              handleModalType={handleModalType}
              sectionID={sectionID}
              layoutItem={openedItem}
              modal={true}
              initialText={initialText}
              fetchText={fetchText}
              onTextSaved={onTextSaved}
            ></CustomReportText>
          )}
          {openedItem.Type === 'file' && (
            <CustomReportFile
              handleModalType={handleModalType}
              sectionID={sectionID}
              layoutItem={openedItem}
              modal={true}
              selectedFile={initialFile}
              fetchFile={fetchFile}
              onFileSaved={onFileSaved}
            ></CustomReportFile>
          )}
          {openedItem.Type === 'creative' && (
            <CustomReportCreative
              handleModalType={handleModalType}
              sectionID={sectionID}
              layoutItem={openedItem}
              modal={true}
              initialCreative={initialCreative}
              fetchCreative={fetchCreative}
              onCreativeSaved={onCreativeSaved}
            />
          )}
        </ModulContainer>
      </HeadModulStyled>
    </Modal>
  );
};

export default CustomReportModalAddNew;
